import React, { useState, useEffect } from 'react';
import TopBar from '../../components/topBar';
import '../../styles/globalStyles.css';
import '../../styles/projectPageStyles.css';

const images = [
  { src: '/projects/dice-bot/dice-bot-1.jpg', alt: 'Dice Bot' },
  { src: '/projects/dice-bot/dice-bot-2.jpg', alt: 'Dice Bot' },
  { src: '/projects/dice-bot/dice-bot-3.jpg', alt: 'Dice Bot' },
  { src: '/projects/dice-bot/dice-bot-4.jpg', alt: 'Dice Bot' },
  { src: '/projects/dice-bot/dice-bot-5.jpg', alt: 'Dice Bot' },
  { src: '/projects/dice-bot/dice-bot-6.jpg', alt: 'Dice Bot' },
];

const DiceBotPage = () => {
  const [lightboxSrc, setLightboxSrc] = useState(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setLightboxSrc(null); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <div className="projectPage">
      <TopBar />

      <div className="projectHero">
        <h1 className="projectTitle">Dice Bot</h1>
      </div>

      <div className="mediaSection">
        <div className="videoSection">
          <p className="sectionLabel">Video</p>
          <div className="videoGrid single">
            <div className="videoWrapper">
              <video className="projectVideo" controls playsInline>
                <source src="/projects/dice-bot/dice-bot-video.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>

        <div className="imageSection">
          <p className="sectionLabel">Photos</p>
          <div className="imageGrid">
            {images.map((img, i) => (
              <div key={i} className="imageWrapper" onClick={() => setLightboxSrc(img.src)}>
                <img className="projectImage" src={img.src} alt={img.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {lightboxSrc && (
        <div className="lightbox" onClick={() => setLightboxSrc(null)}>
          <button className="lightboxClose" onClick={() => setLightboxSrc(null)}>×</button>
          <img
            className="lightboxImage"
            src={lightboxSrc}
            alt="expanded"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default DiceBotPage;
